var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejctIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26634 9.66659L0.333008 8.73325L4.06634 4.99992L0.333008 1.26659L1.26634 0.333252L4.99967 4.06659L8.73301 0.333252L9.66634 1.26659L5.93301 4.99992L9.66634 8.73325L8.73301 9.66659L4.99967 5.93325L1.26634 9.66659Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejctIcon);
export default __webpack_public_path__ + "static/media/rejctIcon.e0a4a94be73afbea6a49c5b8e7a8eed8.svg";
export { ForwardRef as ReactComponent };